function addLike({ contentId }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/likes`;
  return apiClient.post(route, { contentId });
}

function removeLike({ contentId }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/likes`;
  return apiClient.delete(route, { contentId });
}

function getLikes({ contentId, size = 6, page }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/likes`;
  return apiClient.get(route, { query: { contentId, size, page } });
}

export default { addLike, removeLike, getLikes };
